import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Home, Calendar, FileText, Activity, User } from 'lucide-react';

const TABS = [
  { to: '/',            icon: Home,     key: 'nav.home' },
  { to: '/appointments',icon: Calendar, key: 'nav.appointments' },
  { to: '/records',     icon: FileText, key: 'nav.records' },
  { to: '/followup',    icon: Activity, key: 'nav.followup' },
  { to: '/profile',     icon: User,     key: 'nav.profile' },
];

export default function BottomNav() {
  const { t } = useTranslation();

  return (
    <nav className="fixed bottom-0 inset-x-0 z-40 bg-white border-t border-gray-100 pb-safe">
      <div className="flex items-center justify-around h-16 px-2">
        {TABS.map(({ to, icon: Icon, key }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            className={({ isActive }) =>
              `flex flex-col items-center gap-0.5 min-w-0 flex-1 py-2 transition-colors ${
                isActive ? 'text-blue-600' : 'text-gray-400 hover:text-gray-600'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <div className={`p-1.5 rounded-xl transition-colors ${isActive ? 'bg-blue-50' : ''}`}>
                  <Icon size={20} strokeWidth={isActive ? 2.5 : 1.8} />
                </div>
                <span className="text-[10px] font-medium truncate">{t(key)}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
